module.exports = __webpack_public_path__ + "static/img/yorkton1.abf0cdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/yorkton1.jpg
// module id = 153
// module chunks = 9